import * as React from 'react';
import { Dispatch, connect } from 'react-redux';
import { IApplicationState, AppActionCreators, ICenterState, IIncidentReportListResponse, IIncidentReportResponse } from '@nkr/store/index';
import { IIncidentReportLookupData, IIncidentReportRequest, IBaseResponse } from '@nkr/models/index';
import { IIncidentReportLookUpResponse, IIncidentReportLogResponse, DashActionCreators } from '@nkr/store/index';
import { Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import * as _ from 'lodash';
import { GridApi, ColumnApi, GridReadyEvent } from 'ag-grid-community';
import { ActionItems } from './action-items';
import Drawer from 'rc-drawer';
import ViewIncidentDetails from './view-incident-details';
import { AxiosError } from 'axios';
import IncidentListSearch from './search';
import { IIncidentReportAddEdit, IRowData } from './models';
import IncidentListGrid from './incident-list-grid';
import * as moment from 'moment';

interface IProps { }

interface IStateProps {
    centers: ICenterState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getIncidentReportList: () => Promise<IIncidentReportListResponse>,
    getIncidentReportLookupData: () => Promise<IIncidentReportLookUpResponse>,
    saveIncidentReport: (incidentreport: IIncidentReportRequest) => Promise<IIncidentReportResponse>,
    saveLogEntry: (id: number, dashRegistrationId: number, actionTaken: number, comments: string) => Promise<IIncidentReportLogResponse>,
    deleteLogEntry: (id: number) => Promise<IBaseResponse>,
    bulkMarkReviewedCompleted: (list: IIncidentReportRequest[]) => Promise<IIncidentReportListResponse>,
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    lookupData: IIncidentReportLookupData,
    listData: IRowData[],
    internalExternal: number,
    search: string,
    incidentCategoryTypeId: number,
    incidentOriginTypeId: number,
    incidentStatusId: number,
    startDate: string,
    endDate: string,
    selectAllRows: boolean,
    centerId: number,
    view: {
        show: boolean,
        drawerHeight: string,
        formData: IIncidentReportAddEdit
    },
    minHeight: number
}

class IncidentList extends React.Component<TProps, IState> {
    readonly state: IState = {
        lookupData: {
            memberCenters: [],
            incidentCategoryTypeList: [],
            incidentOriginTypeList: [],
            incidentStatusList: [],
            actionList: [],
            mentorList: [],
            userId: 0,
            fullName: '',
            donorConnectGroup: 0
        },
        listData: [],
        internalExternal: 0,
        search: '',
        incidentCategoryTypeId: 0,
        incidentOriginTypeId: 0,
        incidentStatusId: 0,
        startDate: '',
        endDate: '',
        selectAllRows: false,
        centerId: 0,
        view: {
            show: false,
            drawerHeight: '',
            formData: null
        },
        minHeight: 400
    }

    gridApi: GridApi;
    columnApi: ColumnApi;
    container: HTMLDivElement;

    onGridReady = (e: GridReadyEvent) => {
        this.gridApi = e.api;
        this.columnApi = e.columnApi;

        e.api.sizeColumnsToFit();
    }

    saveContainer = (container: HTMLDivElement) => {
        this.container = container;
    };

    getContainer = () => {
        return this.container;
    };

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Loading incident reports, one moment please...').then(() => {
            return Promise.all([
                this.props.getIncidentReportLookupData(),
                this.props.getIncidentReportList(),
            ]).then(([lookUpResponse, reportListResponse]) => {
                if (lookUpResponse.data.success) {
                    let lookupData = lookUpResponse.data.results;

                    let listData = reportListResponse.data.results.map(x => {
                        return {
                            ...x,
                            isSelected: false
                        }
                    });

                    this.setState({
                        lookupData,
                        listData
                    });
                }
                this.props.hideLoading();
            });
        });
    }

    filteredData = () => {
        let incidentreports = this.state.listData.filter(report => {
            let incidentStatusId = this.state.incidentStatusId > 0 ? report.incidentStatusId == this.state.incidentStatusId : true;
            let incidentOriginTypeId = this.state.incidentOriginTypeId > 0 ? report.incidentOriginTypeId == this.state.incidentOriginTypeId : true;
            let incidentCategoryTypeId = this.state.incidentCategoryTypeId > 0 ? report.incidentCategoryTypeId == this.state.incidentCategoryTypeId : true;
            let centerId = this.state.centerId > 0 ? report.centerId == this.state.centerId : true;
            let startDate = moment(this.state.startDate).isValid() ? moment(this.state.startDate).isSameOrBefore(moment(report.incidentDate)) : true;
            let endDate = moment(this.state.endDate).isValid() ? moment(this.state.endDate).isSameOrAfter(moment(report.incidentDate)) : true;

            let search = (this.state.search != '' ? report.centerName.toUpperCase().indexOf(this.state.search.toUpperCase()) >= 0 : true) ||
                (this.state.search != '' ? report.candidateFirstName.toUpperCase().indexOf(this.state.search.toUpperCase()) >= 0 : true) ||
                (this.state.search != '' ? report.candidateLastName.toUpperCase().indexOf(this.state.search.toUpperCase()) >= 0 : true) ||
                (this.state.search != '' ? report.incidentOriginType.toUpperCase().indexOf(this.state.search.toUpperCase()) >= 0 : true) ||
                (this.state.search != '' ? report.incidentCategoryType.toUpperCase().indexOf(this.state.search.toUpperCase()) >= 0 : true) ||
                (this.state.search != '' ? report.assignedMentorName.toUpperCase().indexOf(this.state.search.toUpperCase()) >= 0 : true) ||
                (this.state.search != '' ? report.incidentStatus.toUpperCase().indexOf(this.state.search.toUpperCase()) >= 0 : true);


            return incidentStatusId && incidentOriginTypeId && incidentCategoryTypeId && centerId && startDate && endDate && search;
        })

        return incidentreports;
    }

    handleSearchChange = (search: string) => {
        this.setState({
            search
        });
    }


    handleStartDateChange = (startDate: string) => {
        this.setState({
            startDate
        });
    }


    handleEndDateChange = (endDate: string) => {
        this.setState({
            endDate
        });
    }

    handleOriginTypeChange = (incidentOriginTypeId: number) => {
        this.setState({
            incidentOriginTypeId
        });
    }

    handleCenterChange = (centerId: number) => {
        this.setState({
            centerId
        });
    }

    handleCategoryTypeChange = (incidentCategoryTypeId: number) => {
        this.setState({
            incidentCategoryTypeId
        });
    }

    handleStatusChange = (incidentStatusId: number) => {
        this.setState({
            incidentStatusId
        });
    }

    handleAddIncidentReport = () => {
        let { userId } = this.state.lookupData;

        this.setState({
            view: {
                show: true,
                drawerHeight: '25vw',
                formData: {
                    id: 0,
                    centerId: 0,
                    // centerName: '',
                    candidateFirstName: '',
                    candidateLastName: '',

                    centerDisplayUserId: userId,
                    // centerDisplayUserName: '',

                    donorConnectGroup: 0,
                    // donorConnectGroupName: '',

                    incidentDate: '',

                    incidentOriginTypeId: 0,
                    // incidentOriginType: '',

                    incidentCategoryTypeId: 0,
                    // incidentCategoryType: '',

                    incidentStatusId: 0,
                    // incidentStatus: '',

                    assignedMentorId: 0,
                    // assignedMentorName: '',

                    description: '',

                    logs: [],
                }
            }
        });
    }

    handleEditIncidentReport = (incidentReportId: number) => {
        let formData = this.state.listData.find(x => x.id == incidentReportId);

        this.setState({
            view: {
                show: true,
                drawerHeight: '',
                formData
            }
        });
    }

    handleAddEditSave = (statusType: number) => {
        let incidentReport = this.state.view.formData;
        incidentReport.incidentStatusId = statusType;

        this.setState({
            view: {
                show: false,
                drawerHeight: '',
                formData: incidentReport.id > 0 ? this.state.view.formData : null
            }
        }, () => {
            this.props.showLoading('Saving incident report, one moment please...').then(() => {
                this.props.saveIncidentReport(incidentReport).then((response) => {
                    if (response.data.success) {
                        toast.success('Successfully saved the incident report', { autoClose: 5000 })
                    }

                    this.props.hideLoading();

                    this.props.getIncidentReportList().then((response) => {
                        if (response.data.success) {
                            let listData = response.data.results.map(x => {
                                return {
                                    ...x,
                                    isSelected: false
                                }
                            });

                            this.setState({
                                listData
                            });
                        }
                    });
                });
            });
        });
    }

    handleAddEditCancel = () => {
        this.setState({
            view: {
                show: false,
                drawerHeight: '',
                formData: null
            }
        });
    }

    handleBulkMarkReviewedCompleted = () => {
        let filteredList = this.filteredData();

        this.props.showLoading('Updating selected to Reviewed/Completed, one moment please...').then(() => {
            this.props.bulkMarkReviewedCompleted(filteredList)
                .then(response => {
                    if (response.data.success) {
                        toast.success('Bulk status updated successfully', { autoClose: 5000 })

                        let listData = response.data.results.map(x => {
                            return {
                                ...x,
                                isSelected: false
                            }
                        });

                        this.setState({
                            listData
                        });

                    }

                    this.props.hideLoading();
                })
        });
    }

    handleSelectAllRows = () => {
        let filteredList = this.filteredData().map(x => x.id);

        let listData = _.cloneDeep(this.state.listData).map(x => {
            if (filteredList.indexOf(x.id) >= 0) {
                x.isSelected = !this.state.selectAllRows;
            }

            return x;
        });

        this.setState({
            listData,
            selectAllRows: !this.state.selectAllRows
        });
    }

    handleRowSelected = (id: number, isSelected: boolean) => {
        let listData = _.cloneDeep(this.state.listData).map(x => {
            if (x.id == id) {
                x.isSelected = isSelected;
            }

            return x;
        });

        this.setState({
            listData
        });
    }

    handleSaveLogEntry = (id: number, incidentReportId: number, actionTaken: number, comments: string) => {
        let message = id == 0 ? 'Adding log entry, one moment please...' : 'Updating log entry, one moment please...';

        this.props.showLoading(message).then(() => {
            this.props.saveLogEntry(id, incidentReportId, actionTaken, comments)
                .then(response => {
                    let listData = _.cloneDeep(this.state.listData).map(item => {
                        if (item.id == incidentReportId) {
                            if (id == 0) {
                                item.logs.push(response.data.results);
                            } else {
                                item.logs = item.logs.map(logItem => {
                                    if (logItem.id == id) {
                                        return response.data.results;
                                    }
                                    return logItem;
                                })
                            }
                        }

                        return item;
                    });

                    let formData = listData.find(x => x.id == incidentReportId);

                    this.setState({
                        listData,
                        view: { show: true, drawerHeight: '', formData }
                    }, () => {
                        this.props.hideLoading();
                        toast.success(id == 0 ? 'Log entry added successfully' : 'Log entry updated successfully');
                    });
                })
                .catch((error: AxiosError) => {
                    this.props.hideLoading();
                });
            ;
        });
    }

    handleDeleteLogEntry = (id: number, dashRegistrationId: number) => {
        this.props.showLoading('Deleting log entry, one moment please...').then(() => {
            this.props.deleteLogEntry(id)
                .then(response => {
                    if (response.data.success) {
                        let listData = _.cloneDeep(this.state.listData).map(item => {
                            if (item.id == dashRegistrationId) {
                                item.logs = item.logs.filter(logItem => logItem.id != id);
                            }

                            return item;
                        });

                        let formData = listData.find(x => x.id == dashRegistrationId);

                        this.setState({
                            listData,
                            view: { show: true, drawerHeight: '', formData }
                        }, () => {
                            this.props.hideLoading();
                            toast.success('Log entry delete successfully');
                        });
                    }
                })
                .catch((error: AxiosError) => {
                    this.props.hideLoading();
                });
            ;
        });
    }

    handleActionItem = (eventKey: string, id: number) => {
        // let data = this.state.incidentReportListData.find(x => x.id == id);

        switch (eventKey) {
            case ActionItems.EDIT:
                this.handleEditIncidentReport(id);
                break;
        }
    }

    handleFieldChange = (id: string, value: any) => {
        let formData = _.cloneDeep(this.state.view.formData);

        if (id == 'firstName') {
            formData.candidateFirstName = value;
        }

        if (id == 'lastName') {
            formData.candidateLastName = value;
        }

        if (id == 'originTypeId') {
            formData.incidentOriginTypeId = parseInt(value);
        }

        if (id == 'centerId') {
            formData.centerId = parseInt(value);
        }

        if (id == 'categoryTypeId') {
            formData.incidentCategoryTypeId = parseInt(value);
        }

        if (id == 'statusId') {
            formData.incidentStatusId = parseInt(value);
        }

        if (id == 'description') {
            formData.description = value;
        }

        if (id == 'assignedMentorId') {
            formData.assignedMentorId = parseInt(value);
        }

        if (id == 'incidentDate') {
            formData.incidentDate = value;
        }

        this.setState({
            view: {
                ...this.state.view,
                formData
            }
        });
    }

    render = () => {
        const data = this.filteredData();

        if (data == null) {
            return null;
        }

        const allowBulk = data.filter(x => x.isSelected).length > 0;

        const incidentStatusList = this.state.lookupData ? this.state.lookupData.incidentStatusList : [];
        const incidentCategoryTypeList = this.state.lookupData ? this.state.lookupData.incidentCategoryTypeList : [];
        const incidentOriginTypeList = this.state.lookupData ? this.state.lookupData.incidentOriginTypeList : [];
        const memberCenterList = this.state.lookupData ? this.state.lookupData.memberCenters : [];

        return (
            <>
                <div ref={this.saveContainer} />

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                    <div>
                        <h1 style={{ margin: 0 }}>Donor Mentor Incident Report List</h1>
                    </div>
                    <div>
                        <Button onClick={this.handleAddIncidentReport}>Add Incident Report</Button>
                    </div>
                </div>

                <IncidentListSearch
                    incidentStatusId={this.state.incidentStatusId}
                    centerId={this.state.centerId}
                    incidentCategoryTypeId={this.state.incidentCategoryTypeId}
                    incidentOriginTypeId={this.state.incidentOriginTypeId}
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    search={this.state.search}
                    incidentStatusList={incidentStatusList}
                    incidentCategoryTypeList={incidentCategoryTypeList}
                    incidentOriginTypeList={incidentOriginTypeList}
                    memberCenters={memberCenterList}
                    onStatusChange={this.handleStatusChange}
                    onCenterChange={this.handleCenterChange}
                    onCategoryTypeChange={this.handleCategoryTypeChange}
                    onOriginTypeChange={this.handleOriginTypeChange}
                    onStartDateChange={this.handleStartDateChange}
                    onEndDateChange={this.handleEndDateChange}
                    onSearchChange={this.handleSearchChange}
                />

                <IncidentListGrid
                    data={data}
                    onGridReady={this.onGridReady}
                    onEdit={this.handleEditIncidentReport}
                    onSelectAllRows={this.handleSelectAllRows}
                    onRowSelected={this.handleRowSelected} />

                <div style={{ paddingTop: 5 }}>
                    <Button bsStyle='primary' disabled={allowBulk == false} onClick={this.handleBulkMarkReviewedCompleted}>Mark Checked as Reviewed/Complete</Button>
                </div>

                <Drawer
                    width='35vw'
                    // handler={false}
                    placement='right'
                    getContainer={this.getContainer}
                    open={this.state.view.show}
                    className='incident-list-view'
                >
                    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                        <div style={{ padding: 10 }}>
                            <ViewIncidentDetails
                                show={this.state.view.show}
                                formData={this.state.view.formData}
                                lookupData={this.state.lookupData}
                                container={this.container}
                                onSave={this.handleAddEditSave}
                                onCancel={this.handleAddEditCancel}
                                onSaveLogEntry={this.handleSaveLogEntry}
                                onDeleteLogEntry={this.handleDeleteLogEntry}
                                onFieldChange={this.handleFieldChange}
                            />
                        </div>
                    </div>
                </Drawer>
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        centers: state.centers
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getIncidentReportList: () => {
            return dispatch(DashActionCreators.getIncidentReportList());
        },
        getIncidentReportLookupData: () => {
            return dispatch(DashActionCreators.getIncidentReportLookupData());
        },
        saveIncidentReport: (incidentreport) => {
            return dispatch(DashActionCreators.saveIncidentReport(incidentreport));
        },
        saveLogEntry: (id, incidentReportId, actionTaken, comments) => {
            return dispatch(DashActionCreators.saveIncidentLogEntry(id, incidentReportId, actionTaken, comments));
        },
        deleteLogEntry: (id) => {
            return dispatch(DashActionCreators.deleteIncidentLogEntry(id));
        },
        bulkMarkReviewedCompleted: (list) => {
            return dispatch(DashActionCreators.bulkMarkReviewedCompleted(list));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(IncidentList);